import { useCallback, useEffect } from 'react';
import Page from '../../../components/page/Page';
import Header from '../../../components/users/Header';
import { useUserCore } from '../../../../core/modules/user';
import { Avatar, Paper, Typography } from '@mui/material';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { useNavigationCore } from '../../../../core/router/navigation';
import { useMeCore } from '../../../../core/modules/me';
import CreateDialog from '../../../components/users/CreateDialog';
import RoleChip from '../../../components/RoleChip';
import { User } from '../../../../core/interfaces/user.interface';
import UpdateDialog from '../../../components/users/UpdateDialog';
import { useGlobalCore } from '../../../../core/modules/global';
import { UPDATE_USER_DIALOG } from '../../../../core/constants/dialog';
import { useCompanyCore } from '../../../../core/modules/company';

const Users = () => {
  const { user } = useMeCore();
  const { openDialog } = useGlobalCore();
  const {
    users,
    noMore,
    setUser,
    increasePage,
    getUsers,
    clearUser,
  } = useUserCore();
  const { getCompanies } = useCompanyCore();
  const { goToWelcome } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (!user || !user.privileges.superAdmin) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    clearUser();
  }, [clearUser]);

  useEffect(() => {
    getUsers({});
  }, [getUsers]);

  const selectUser = useCallback((user: User) => {
    getCompanies({});
    setUser(user);
    openDialog(UPDATE_USER_DIALOG);
  }, [getCompanies, openDialog, setUser]);

  return (
    <>
      <Page
        header={<Header />}
        content={
          !users.length ? (
            <div className="flex flex-1 items-center justify-center h-full">
              <Typography color="text.secondary" variant="h5">
                No hay usuarios creados
              </Typography>
            </div>
          ) : (
            <div className="w-full my-16 sm:col-span-3 px-24 md:px-32">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-24 w-full min-w-0">
                {users.map((user : User) => (
                  <Paper
                    className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden cursor-pointer"
                    key={user.id}
                    onClick={() => selectUser(user)}
                  >
                    <div className="flex flex-col flex-auto w-full p-32 items-center text-center">
                      <Avatar
                        alt="user photo"
                        className="w-128 h-128"
                      />
                      <div className="mt-24 mb-12">
                        <RoleChip roles={user.privileges} />
                      </div>
                      <Typography className="font-medium text-slate-950">
                        {user.name}
                      </Typography>
                      <Typography>{user.email}</Typography>
                    </div>
                  </Paper>
                ))}
              </div>
              {!noMore ? (
                <div className="text-center underline cursor-pointer my-24" onClick={increasePage}>
                  Mostras más
                </div>
              ) : null}
            </div>
          )
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CreateDialog />
      <UpdateDialog />
    </>
  );
};

export default Users;
